<template lang="pug">
    v-flex(justify-self-center :class="[$vuetify.breakpoint.smAndDown ? 'text-xs-center' : 'text-xs-right']")
        v-btn(color="primary" :rounded="rounded" :disabled="disabled" @click="onClick")
            v-icon(left dark) {{icon}}
            span {{caption}}
</template>

<script>
export default {
  name: "AddNewButton",
  props: {
    rounded: Boolean,
    disabled: Boolean,
    caption: String,
    icon: {
      type: String,
      default: "mdi-plus-circle-outline"
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style scoped></style>
